<template>
  <div class="visit-register-section">
    <div class="visit-register-header">
      <div class="logo-2">
        <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
      </div>
      <p class="form-title">
        {{
          this.$route.query.add_visitor
          ? $t('preRegisteration.confirm_visit_invitation')
            : $t('common.registerVisit')
        }}
      </p>
      <div class="section-container">
        <RenderFieldType
          :preReg="true"
          :addSeperator="true"
          :section="section"
          @updateCustomField="updateCustomField"
        />
        <button
          class="next-btn"
          :disabled="$v.section.$invalid || getIsLoading"
          @click="nextHandler"
        >
          <i
            v-if="getIsLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          {{ isLastTab ? $t('common.confirm') : $t('common.next').toUpperCase() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RenderFieldType from "@/components/users/section/RenderFieldType";
import { cloneDeep } from "lodash";
import { requiredIf } from "vuelidate/lib/validators";
export default {
  components: {
    RenderFieldType,
  },
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
    isLastSection: {
      type: Boolean,
      default: false,
    },
    isLastTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      section: null,
    };
  },
  validations: {
    section: {
      custom_fields: {
        $each: {
          value: {
            required: requiredIf(function (field) {
              return field.is_mandatory;
            }),
          },
        },
      },
    },
  },
  mounted() {
    this.section = cloneDeep(this.sectionData);
  },
  computed: {
    ...mapGetters("preRegistration", ["getIsLoading"]),
  },
  methods: {
    updateCustomField(field) {
      let updatedFieldIndex = this.section.custom_fields?.findIndex(
        (customField) => customField.id == field.id
      );
      if (updatedFieldIndex >= 0)
        this.section.custom_fields[updatedFieldIndex] = field;
      this.section = cloneDeep(this.section);
      this.$emit("updateCustomField", this.section);
    },
    nextHandler() {
      if (this.isLastSection) this.$emit("updateShowSections", false);
      this.$emit("nextAction", this.isLastSection);
    },
  },
};
</script>

<style lang="scss">
.visit-register-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  width: 491px;
  margin-top: 62px;
  margin-bottom: 62px;
  text-align: center;
  background-color: #ffffff;
  .visit-register-header {
    .logo-2 {
      margin: auto;
      width: 116px;
      height: 22px;
      margin-top: 48px;
      margin-bottom: 24px;
      img {
        width: 86px;
        height: 16px;
      }
    }
    .form-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      margin-bottom: 12px;
      color: #000000;
    }
    .sub-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: #666666;
      margin-bottom: 36px;
      .login-btn {
        color: #103f5e;
        font-weight: 700;
      }
    }
  }
  .content {
    margin: 0 39px 0 38px;
    font-size: 16px;

    .first-last-name-wrapper {
      display: flex;
      // margin-bottom: 14px;
      .required-star {
        position: relative;
        .required {
          color: #e51414;
          position: absolute;
          inset-inline-end: 22px;
          top: 18px;
          z-index: 1000;
          font-size: 1.2rem;
        }
      }
      .first-name {
        margin-inline-end: 14px;
        width: 200px;
        // height: 55px;
      }
      .last-name {
        width: 200px;
        // height: 55px;
      }
    }
    .current-phone {
      margin-bottom: 36px;
      .phone-group {
        display: flex;
      }
      .country-code-input {
        margin-inline-end: 14px;
      }
    }
    .current-phone .phone-group .country-code-input {
      width: 106px;
      height: 55px;
      background-color: #f2f2f2;
      border-radius: 4px;
      border: none;
    }
    .passport-email-phone {
      margin-bottom: 32px;
    }
    .email-wrapper {
      .err-wrapper {
        margin-top: -9px;
        margin-bottom: 6px;
        // margin-inline-start: -115px;
      }
    }
    .current-phone {
      .err-wrapper {
        margin-top: 3px;
        margin-bottom: 6px;
        margin-inline-start: -110px;
      }
    }
    .register-account-check-wrapper {
      display: flex;

      margin-inline-end: 27px;
      margin-inline-start: 27px;
      margin-bottom: 133px;
      // .custom-checkbox-dark {
      // margin-inline-end: 15px;
      // }
      .text {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0.25px;
        color: #666666;
        text-align: start;
        margin-inline-start: 16px;
      }
    }
  }
}
.section-container {
  width: 490px;
  // height: 730px;
  background: #ffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // margin-top: 62px;
  border-radius: 26px;
  padding: 20px;
  h4.rating-title-add {
    text-align: start !important;
  }
  .form-group {
    display: grid;
    justify-content: flex-start;
  }
  .bv-no-focus-ring {
    display: grid;
    justify-items: flex-start;
  }
  .section-title {
    font-size: 17px !important;
    font-weight: 700 !important;
    line-height: 20.4px !important;
    text-align: center !important;
    color: #000 !important;
  }
  button.next-btn:disabled {
    opacity: 0.4;
  }
}
.next-btn {
  display: block;
  width: 415px;
  height: 44px;
  margin: 0 auto 38px auto;
  border-radius: 22px;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
  background-color: #103f5e;
  margin-top: 40px;
}
@media (max-width: 992px) {
  .visit-register-section,
  .section-container {
    width: 360px;
  }
  .number-in-con .md-field.md-theme-default.md-inline,
  .text-input .md-field.md-theme-default.md-inline,
  .custom-rating-date .pre-reg-datepicker input.mx-input,
  .mx-input-wrapper,
  .toggle-rating-con .mandatory,
  .toggle-rating-con .filled-by,
  .toggle-rating-con .padge,
  .long-text-con .md-field.md-theme-default.md-has-textarea,
  .md-field,
  .next-btn {
    width: 312px !important;
  }
  .vp-width-416 {
    width: 320px;
  }
}
</style>
